import React, { useState, useEffect } from 'react';
import Modal from './Modal';
import { showToast } from '../Utils/toast';

const SongFormModal = ({
  isOpen,
  onClose,
  onSubmit,
  userPlaylists = [],
  isLoading = false
}) => {
  const [query, setQuery] = useState('');
  const [playlistId, setPlaylistId] = useState(undefined);

  useEffect(() => {
    if (isOpen) {
      // Reset form when modal opens
      setQuery('');
      setPlaylistId(undefined);
    }
  }, [isOpen]);

  const handleSubmit = (e) => {
    e.preventDefault();

    // Validation
    const trimmedQuery = query.trim();
    if (!trimmedQuery) {
      showToast.error('Please enter a YouTube or SoundCloud link');
      return;
    }

    onSubmit(trimmedQuery, playlistId, playlistId === undefined);
    setQuery('');
  };

  return (
    <Modal
      isOpen={isOpen}
      onClose={onClose}
      title="Add Song"
      size="md"
    >
      <form onSubmit={handleSubmit} className="space-y-4">
        {/* URL Input */}
        <div>
          <label
            htmlFor="song-url"
            className="block text-sm font-medium text-text mb-2"
          >
            YouTube or SoundCloud URL
          </label>
          <input
            id="song-url"
            type="text"
            value={query}
            onChange={(e) => setQuery(e.target.value)}
            placeholder="Paste YouTube or SoundCloud link here!"
            autoFocus
            disabled={isLoading}
            className="
              w-full px-3 py-2 bg-transparent border border-neutral-700 focus:border-accent rounded-lg text-text placeholder:opacity-50 transition-colors focus:outline-none disabled:opacity-50 disabled:cursor-not-allowed
            "
          />
        </div>

        {/* Playlist Select */}
        <div>
          <label
            htmlFor="playlist-select"
            className="block text-sm font-medium text-text mb-2"
          >
            Add to Playlist
          </label>
          <select
            id="playlist-select"
            onChange={(e) => {
              const { value } = e.target;
              if (value !== "public") {
                setPlaylistId(parseInt(value));
              } else {
                setPlaylistId(undefined);
              }
            }}
            disabled={isLoading}
            className="
              w-full px-3 py-2 bg-transparent border border-neutral-700 focus:border-accent rounded-lg text-text transition-colors focus:outline-none disabled:opacity-50 disabled:cursor-not-allowed appearance-none cursor-pointer
            "
            style={{
              backgroundImage: `url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' fill='none' viewBox='0 0 24 24' stroke='%23000'%3E%3Cpath stroke-linecap='round' stroke-linejoin='round' stroke-width='2' d='M19 9l-7 7-7-7'%3E%3C/path%3E%3C/svg%3E")`,
              backgroundRepeat: "no-repeat",
              backgroundPosition: "right 0.5rem center",
              backgroundSize: "1.5em 1.5em",
              paddingRight: "2.5rem"
            }}
          >
            <option value="public" className="bg-primary text-text">
              Public
            </option>
            {userPlaylists
              .filter(playlist => !playlist.isVirtual) // Filter out virtual playlists
              .map((playlist) => (
                <option
                  key={`playlist-${playlist.id}`}
                  value={playlist.id}
                  className="bg-primary text-text"
                >
                  {playlist.title}
                </option>
              ))}
          </select>
        </div>

        {/* Actions */}
        <div className="flex gap-3 mt-6 pt-4 border-t border-secondary">
          <button
            type="button"
            onClick={onClose}
            disabled={isLoading}
            className="
              flex-1 px-4 py-2 text-text hover:bg-secondary rounded-lg transition-colors disabled:opacity-50 disabled:cursor-not-allowed
            "
          >
            Cancel
          </button>
          <button
            type="submit"
            disabled={isLoading}
            className="
              flex-1 px-4 py-2 bg-accent text-white rounded-lg hover:opacity-90 transition-opacity disabled:opacity-50 disabled:cursor-not-allowed font-medium
            "
          >
            {isLoading ? 'Adding...' : 'Add Song'}
          </button>
        </div>
      </form>
    </Modal>
  );
};

export default SongFormModal;
